import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";
import cancelImage from "../../../../public/images/icons/icon_ionic-md-close-circle-2.svg";
import logo from "../../../../shared-assets/images/header/logo.png";
import Category from "../../../../shared-assets/Svg/Category.svg";
import Club from "../../../../shared-assets/Svg/Club.svg";
import Enter from "../../../../shared-assets/Svg/Enter.svg";
import SearchIcon from "../../../../shared-assets/Svg/SearchMod.svg";
import { API } from "../../../services/api-services";
import AppContext from "../../../services/app-context-services";
import { trackEvent } from "../../../services/ga-services";
import { ROUTES } from "../../../services/router-services";
import { ToPersianNumber } from "../helper/helper";
import { Mask } from "../mask/mask";
import SearchBar from "../search2/searchBar";
import styles from "./header.module.scss";
import { ProfilePopUp } from "./ProfilePopUp";

type HeaderProps = {
  isTransparentHeader?: boolean;
};

const Header = ({ isTransparentHeader }: HeaderProps) => {
  const { closeSearchModal, setCloseSearchModal } = useContext(AppContext);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showVpnHeader, setShowVpnHeader] = useState(false);
  const [isFocus, setIsFocus] = useState(false);
  const [scrollDirection, setScrollDirection] = useState<"UP" | "DOWN">("UP");
  const [prevScrollPosition, setPrevScrollPosition] = useState(0);
  const { isLoggedIn, profile, isIntlUser } = useContext(AppContext);
  const router = useRouter();
  const patch = router.pathname;
  const pathname = patch.substring(1).split("/")[0];
  const showNavbarCondition = ["", "login", "category", "menu"];
  const showNavbar = showNavbarCondition.some(patch => patch === pathname);

  const handleFocus = () => {
    setIsFocus(false);
  };
  useEffect(() => {
    setShowVpnHeader(isIntlUser);
  }, [isIntlUser]);

  useEffect(() => {
    if (!closeSearchModal) return;
    const handleRouteChange = () => {
      setIsFocus(false);
      setShowSearchBar(false);
      setCloseSearchModal(false);
    };
    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [closeSearchModal]);

  // useEffect(() => {
  //   const handleRouteChange = url => {
  //     setIsFocus(false);
  //     setShowSearchBar(false);
  //   };

  //   router.events.on("routeChangeComplete", handleRouteChange);

  //   return () => {
  //     router.events.off("routeChangeComplete", handleRouteChange);
  //   };
  // }, []);
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      if (currentScrollPos > prevScrollPosition) {
        scrollDirection !== "DOWN" && setScrollDirection("DOWN");
      } else {
        scrollDirection !== "UP" && setScrollDirection("UP");
      }
      setPrevScrollPosition(currentScrollPos);
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [prevScrollPosition]);

  return (
    <>
      {showVpnHeader && (
        <header className={styles.headerIntlUser}>
          <div className={styles["vpn-header"]}>
            {false && (
              <div
                className={styles["close-btn"]}
                onClick={() => setShowVpnHeader(false)}
              >
                <Image src={cancelImage} alt="close" layout="fill" />
              </div>
            )}
            <div className={styles["message"]}>
              برای استفاده بهتر از دیجیتون و تماشای همه کارتون‌ها لطفا VPN رو
              خاموش کن.
            </div>
          </div>
        </header>
      )}
      {isIntlUser === false && (
        <>
          <header
            className={`${styles.header} ${
              scrollDirection === "DOWN" &&
              isTransparentHeader &&
              !showSearchBar &&
              styles.headerShowFade
            } ${
              isTransparentHeader &&
              prevScrollPosition < 200 &&
              styles.transparent
            }`}
            style={showSearchBar ? { padding: "0px" } : {}}
          >
            <div
              className={`${styles.wrapper} ${
                !showSearchBar && "i-container"
              } `}
            >
              <div
                className={styles.rightSection}
                style={showSearchBar ? { display: "none" } : {}}
                onClick={() => {
                  trackEvent("Header", "Logo");
                }}
              >
                <Link href={ROUTES.root} prefetch={false}>
                  <a className={styles.logo}>
                    <Image src={logo} alt="Logo" layout="fill" />
                  </a>
                </Link>
              </div>

              <SearchBar
                setShowSearchBar={setShowSearchBar}
                showSearchBar={showSearchBar}
                setIsFocus={setIsFocus}
                isFocus={isFocus}
              />

              <div
                className={styles.leftSection}
                style={showSearchBar ? { display: "none" } : {}}
              >
                <div className={styles.navbar}>
                  {isLoggedIn && profile?.avatar ? (
                    <div className={styles.profileContainer}>
                      <a
                        className={styles.icon}
                        style={{ borderRadius: "50px" }}
                      >
                        <span className={styles.avatar}>
                          <Image
                            src={profile.avatar}
                            width={40}
                            height={40}
                            alt="avatar"
                          />
                        </span>
                        <span className={styles.label}>
                          {profile?.first_name
                            ? profile?.first_name
                            : profile?.last_name
                            ? profile.last_name
                            : profile?.nickname
                            ? profile.nickname
                            : profile?.mobile
                            ? ToPersianNumber(profile?.mobile)
                            : profile?.email}
                        </span>
                        {/* <span className={styles.notic}></span> */}
                      </a>
                      <ProfilePopUp />
                    </div>
                  ) : (
                    <button
                      className={styles.button}
                      onClick={() => router.push(ROUTES.login)}
                    >
                      <span className={styles.buttonIcon}>
                        <Enter />
                      </span>
                      ورود{" "}
                      <span className={styles.buttonSecondValue}>
                        به دیجیتون
                      </span>
                    </button>
                  )}

                  {/* <Link href={API.club_site} prefetch={false}>
                    <a className={`${styles.icon}`}>
                      <span className={styles.svg}>
                        <Club />
                      </span>
                      <span className={styles.label}>دیجیتون کلاب</span>

                      <span className={styles.notic}></span>
                    </a>
                  </Link> */}
                  <Link href={ROUTES.categories} prefetch={false}>
                    <a className={styles.icon}>
                      <span className={styles.svg}>
                        <Category />
                      </span>
                      <span className={styles.label}>دسته‌بندی</span>

                      {/* <span className={styles.notic}></span> */}
                    </a>
                  </Link>
                </div>

                <div
                  className={styles.searchIconWrapper}
                  onClick={() => setShowSearchBar(!showSearchBar)}
                >
                  <a
                    className={styles.iconSearch}
                    style={{
                      stroke:
                        isTransparentHeader && prevScrollPosition < 200
                          ? "white"
                          : "#4A5783"
                    }}
                  >
                    <SearchIcon style={{ width: "100%", height: "100%" }} />
                  </a>
                  <span
                    style={{
                      color:
                        isTransparentHeader && prevScrollPosition < 200
                          ? "white"
                          : "#4A5783"
                    }}
                  >
                    جستجو
                  </span>
                </div>
              </div>
            </div>
          </header>
        </>
      )}
      {isFocus && (
        <Mask handleCloser={handleFocus} showMask={isFocus} zIndex={90} />
      )}
    </>
  );
};

export default Header;
